
import { systemVariableList } from '@/api/form'
const state = {
  system: [],
  systemItem: {},
  dynamicSystem: [] // 動態查詢的數據
}

const mutations = {
  // 下拉结构数据
  SET_SYSTEM: (state, system) => {
    state.system = system
  },
  // 全量系统数据
  SET_SYSTEM_ITEM: (state, systemItem) => {
    state.systemItem = systemItem
  },
  SET_DYNAMIC_SYSTEM_List: (state, dynamicSystem) => {
    state.dynamicSystem = dynamicSystem
  }
}

const actions = {
  async getSystem({ commit }) {
    const dynamicData = []
    const res = await systemVariableList()
    if (res && res.code === 200 && res.data) {
      const { organizationalStructure, date, systemData } = res.data
      const systemList = []
      const systemItem = {}
      if (organizationalStructure) {
        systemList.push({
          label: '组织架构',
          options: organizationalStructure
        })
        organizationalStructure.forEach((item) => {
          if (item.code && !systemItem[item.code]) {
            systemItem[item.code] = item
            if (item.dynamic) {
              dynamicData.push(item)
            }
          }
        })
      }
      if (date) {
        systemList.push({
          label: '日期',
          options: date
        })
        date.forEach((item) => {
          if (item.code && !systemItem[item.code]) {
            systemItem[item.code] = item
            if (item.dynamic) {
              dynamicData.push(item)
            }
          }
        })
      }
      if (systemData) {
        systemList.push({
          label: '系统数据',
          options: systemData
        })
        systemData.forEach((item) => {
          if (item.code && !systemItem[item.code]) {
            systemItem[item.code] = item
            if (item.dynamic) {
              dynamicData.push(item)
            }
          }
        })
      }
      console.log('dynamicData', dynamicData)
      commit('SET_DYNAMIC_SYSTEM_List', dynamicData)
      commit('SET_SYSTEM', systemList)
      commit('SET_SYSTEM_ITEM', systemItem)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
